//angular imports
import {
    ChangeDetectionStrategy,
    Component, 
    WritableSignal, 
    signal,
} from '@angular/core';

//local imports
import { PresenterType } from '@shared/components';
import { ProjectUpdatedMessage } from './project-updated.message';

@PresenterType(
{
    model: ProjectUpdatedMessage
})
@Component({
    selector: 'project-updated-message-template',
    templateUrl: './project-updated-message-template.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ProjectUpdatedMessageTemplateComponent
{
    public data: WritableSignal<ProjectUpdatedMessage>;
    
    constructor() {
        this.data = signal<ProjectUpdatedMessage>(null);
    }
}